'use client';

import Footer from '../global/partials/Footer';
import HeaderV2 from '../global/partials/HeaderV2';
import { PageGeneralRulesV3Schema } from '@/sanity/pages/PageGeneralRulesV3Template';
import HeroSection from '../pageComponents/general-rules-v3/HeroSection';
import RulesBody from '../pageComponents/general-rules-v3/RulesBody';
import ScrollingBanner from '../pageComponents/global/ScrollingBanner';

export default function PageGeneralRulesV3JSX({ data }: { data: PageGeneralRulesV3Schema }) {
  return (
    <main className="flex flex-col items-center">
      {data?.settings?.header && (
        <HeaderV2
          data={data.settings.header}
          headerStyle="light"
          headerType="main"
          language={data.settings?.language}
        />
      )}

      <HeroSection data={data} />
      <RulesBody data={data} />

      {/* Ticker + footer: identical to the home page. */}
      <ScrollingBanner
        className="border-y-0 bg-[#f4f5f5]"
        words={data.scrollingWords?.words}
        wordsI18n={data.scrollingWords?.wordsI18n}
      />
      {data?.settings?.footer && (
        <Footer
          data={data.settings?.footer}
          finalCta={data}
          language={data?.settings?.language}
        />
      )}
    </main>
  );
}
